import React from 'react';
import { connect } from 'react-redux';

// Actions
import { setAdvancedOptions, setEditAdvancedOptions } from '../../../actions/stepsChat';

// Components
import GreenSwitch from '../../GreenSwitch/GreenSwitch';

// Kit
import { Card } from '@/components/ui';

const ButtonVisibility = ( props ) => {

    // Actions
    const { setEditAdvancedOptions, advancedOptions } = props;

    // States
    const { buttonVisibility } = props;

    const handleChangeVisibility = () => {

        setEditAdvancedOptions({
            editAdvancedOptions: true
        });

        advancedOptions({
            buttonVisibility: !buttonVisibility
        });
    }

    return (
        <Card className="mb-6 flex items-center justify-between gap-4 p-5">
            <div className="min-w-0">
                <h2 className={`text-[15px] font-semibold leading-tight tracking-[-0.01em] ${buttonVisibility ? 'text-foreground' : 'text-muted-foreground'}`}>
                    Visibilidad del botón WhatsPRO
                </h2>
                <p className="mt-1 text-[13px] text-muted-foreground">
                    Al deshabilitar el botón, se ocultará el chat en tu tienda.
                </p>
            </div>
            <div className="shrink-0">
                <GreenSwitch
                    onClick={ () => handleChangeVisibility() }
                    checked={ buttonVisibility }
                />
            </div>
        </Card>
    )
}

const mapStateToProps = state => {
    return {
        buttonVisibility: state.stepsChat.advancedOptions.buttonVisibility,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setEditAdvancedOptions: (value) => dispatch(setEditAdvancedOptions(value)),
        advancedOptions: (value) => dispatch(setAdvancedOptions(value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)( ButtonVisibility );